import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Select, Divider, Modal, Checkbox, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";
import svg12 from "../../assets/svg/svg12.svg";
import { rolesData } from "../../data";
import PhoneInput from "react-phone-input-2";

const UserAdd = ({ isModalOpen, handleCancel, prodd, handleFetch }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();

  const plainOptions = ["EDIT", "VIEW"];

  const onFinish = async (data) => {
    data.id = prodd?.id ? prodd?.id : null;
    data.password = 1234
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/users",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  const role = Form.useWatch("role", form);

  return (
    <Modal
      title={
        <div className="flex gap-[1.25rem] mb-[1.25rem]">
          <div className="rounded-[.25rem] bg-[#D6E1F5] h-[3rem] w-[3rem] flex items-center justify-center">
            <img src={svg12} alt="svg12" />
          </div>
          <div className="flex flex-col ">
            <span className="typography_3">Adding a new user</span>
            <span className="typography">Fill with relevant information.</span>
          </div>
        </div>
      }
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <div className="-mx-9">
        <Divider />
      </div>
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className="mt-[2.5rem]"
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-[1.25rem]">
          <Form.Item
            name="firstname"
            label={"First Name"}
            rules={[
              {
                required: true,
                message: "Please add first name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>

          <Form.Item
            name="lastname"
            label={"Last Name"}
            rules={[
              {
                required: true,
                message: "Please add last name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
        </div>

        <Form.Item
          name="email"
          label={"Email"}
          rules={[
            {
              required: true,
              message: "Please add email address",
            },
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input type="email" className="input" />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label={"Mobile Number"}
          rules={[
            {
              required: true,
              message: "Please add mobile number",
            },
          ]}
        >
          <PhoneInput
            country="ke"
            onlyCountries={["ke"]}
            countryCodeEditable={false}
            className="input rounded-[6px] border !border-[#cacaca] !h-[92px]"
          />
        </Form.Item>

        <Form.Item
          name="role"
          className=""
          label={"Role"}
          rules={[
            {
              required: true,
              message: "Please select role",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              rolesData?.length > 0 &&
              rolesData?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        
        {role === "USER" && (
          <Form.Item
            name="rights"
            className=""
            rules={[
              {
                required: true,
                message: "Please select rights",
              },
            ]}
          >
            <Checkbox.Group options={plainOptions} />
          </Form.Item>
        )}

        <div className="flex justify-between mt-[1.25rem] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default UserAdd;
